import React from "react";
import { API_BASE } from "../../admin/api";

export default function TeamCard({ item, onEdit, onDelete }) {
  const imgSrc = item.image ? `${API_BASE}${item.image}` : null;

  return (
    <article className="team-card">
      <div className="team-card__thumb">
        {imgSrc ? (
          <img src={imgSrc} alt={item.name} loading="lazy" />
        ) : (
          <div className="team-card__thumb--empty">No Image</div>
        )}
      </div>

      <div className="team-card__body">
        <h3 className="team-card__title">{item.name}</h3>
        <p className="team-card__sub">{item.designation}</p>

        <div className="team-card__actions">
          <button className="btn btn--ghost" onClick={() => onEdit(item)} title="Edit">
            <span className="i i-edit" aria-hidden="true" /> Edit
          </button>
          <button className="btn btn--danger" onClick={() => onDelete(item.id)} title="Delete">
            <span className="i i-trash" aria-hidden="true" /> Delete
          </button>
        </div>
      </div>
    </article>
  );
}
